module.exports = __webpack_public_path__ + "static/media/calendar-alt-regular.b4914e42.svg";